import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AdminTokenService } from '../services/admin-token.service';

/**
 * Guard สำหรับหน้า admin ที่ต้อง login
 * เช็คแค่ admin token + ยังไม่หมดอายุฝั่ง client (ไม่ยิง API)
 * Skip guard ฝั่ง SSR — client hydrate ค่อยตรวจอีกที (กัน flash login page)
 */
export const adminAuthGuard: CanActivateFn = (_route, state) => {
  const platformId = inject(PLATFORM_ID);
  // SSR: ให้ผ่านไปก่อน — cookie เข้าถึงไม่ได้ฝั่ง server → client จะเช็คอีกครั้งหลัง hydrate
  if (!isPlatformBrowser(platformId)) return true;

  const tokenSvc = inject(AdminTokenService);
  const router   = inject(Router);

  if (tokenSvc.isExpired()) {
    // Clear stale cookies inline — ไม่เรียก adminSignout() เพราะมันจะ trigger navigation ซ้อน
    tokenSvc.clear();
    return router.createUrlTree(['/admin/account'], {
      queryParams: { returnUrl: state.url },
    });
  }
  return true;
};
